import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, useIntl } from 'react-intl';
import Cookies from 'js-cookie';

import { setIntl } from './helpers/IntlInstance';

const ignoreDefaulMessageError = (error) => {
  if (process.env.MIX_ENV === 'local') {
    if (typeof error.message === 'string' && error.message.includes('[@formatjs/intl Error MISSING_TRANSLATION]')) {
      return false;
    }
  }
  return error;
};

const IntlWrapper = ({ children, profile, languageMessages }) => {
  let lang = 'en';
  if (profile && profile.language) {
    lang = profile.language;
  } else if (Cookies.get('sp-language')) {
    lang = Cookies.get('sp-language');
  }

  return (
    <IntlProvider
      locale={lang}
      messages={languageMessages}
      defaultRichTextElements={{
        strong: chunks => <strong>{chunks}</strong>,
        br: <br />,
        p: chunks => <p>{chunks}</p>,
      }}
      onError={ignoreDefaulMessageError}
    >
      <IntlInitializer>{children}</IntlInitializer>
    </IntlProvider>
  );
};

const IntlInitializer = ({ children }) => {
  IntlInitializer.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const intl = useIntl();

  useEffect(() => {
    setIntl(intl);
  }, [intl]);

  return <>{children}</>;
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  languageMessages: state.App.languageMessages,
});

IntlWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  profile: PropTypes.object,
  languageMessages: PropTypes.object.isRequired,
};

IntlWrapper.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(IntlWrapper);
